//
// Module for the service purchase defaults view
//
rs.module("content/system/configuration/servicepurchase/defaults",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, backendUrl, grid) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var payoffUpdateToken = form.js(jsSelectors.payoffUpdateToken);
            var payoffKey = form.js(jsSelectors.payoffKey);
            var payoffDownPaymentInput = form.js(jsSelectors.payoffDownPaymentInput);
            var payoffNumberOfPaymentsInput = form.js(jsSelectors.payoffNumberOfPaymentsInput);
            var payoffPaymentFrequencySelect = form.js(jsSelectors.payoffPaymentFrequencySelect);
            var addPaymentPlanButton = form.js(jsSelectors.addPaymentPlanButton);
            var cancelPaymentPlanButton = form.js(jsSelectors.cancelPaymentPlanButton, { required: false });

            // Get Select Helpers for populating drop downs
            var payoffPaymentFrequencySelectHelper = selectHelper.getHelper(payoffPaymentFrequencySelect);

            // On add button click, clear the detail form
            addPaymentPlanButton.click(function () {

                eventBanner.removeAllMessages();
                grid.selectedValues = null;

                payoffKey.val(-1);

                // Reset inputs
                [
                    payoffUpdateToken,
                    payoffDownPaymentInput,
                    payoffNumberOfPaymentsInput
                ].forEach((input) => input.clearErrors().val(''));
                payoffDownPaymentInput.val('$0.00');

                // Reset selectors
                payoffPaymentFrequencySelectHelper.addEmptyOption();
                payoffPaymentFrequencySelectHelper.selectIndex(0);
            });

            // On cancel button click, select first entry and clear event banner.
            cancelPaymentPlanButton.click(function () {
                payoffPaymentFrequencySelectHelper.removeEmptyOption();
                grid.selectedValues = null;
                grid.selectFirstRow();
                eventBanner.removeAllMessages();
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    $.getJSON(backendUrl, { spcPaymentOptionKey: values[0] }).done(function (data) {

                        payoffUpdateToken.val(data.updateToken);
                        payoffKey.val(data.payoffOptionKey);
                        payoffDownPaymentInput.val(data.downPaymentAmt);
                        payoffNumberOfPaymentsInput.val(data.numberOfPayments);
                        payoffPaymentFrequencySelectHelper.setValue(data.paymentFrequency);

                        eventBanner.removeAllMessages();
                    });
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);